import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||393}
    height={undefined}
    viewBox="0 0 393 25"
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeDasharray="8 8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M180.5 12H-15M213 12h195.5"
    />
    <path
      fill="#fff"
      d="M200.099 8.907 196.505 0l-3.604 8.907L184 12.5l8.901 3.593L196.505 25l3.594-8.907L209 12.5l-8.901-3.593Z"
    />
  </svg>
)
export default SvgComponent
